import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Invitation } from '../models/invitation';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private httpClient: HttpClient) {
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  sendInvitation(invitation: Invitation) {
    var body = {
      "from": invitation.inviterName,
      "to": invitation.inviteeEmail,
      "group": invitation.groupName
    };

    return this.httpClient.post(environment.emailApiUrl, body, this.httpOptions);
  }
}
